import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { type ActionMethods, type UserSelfPageData } from '..';
import PageTitle from '../PageTitle';
import { ActionButton } from '../styled';
import ChangePasswordContent from './ChangePasswordContent';

const useChangePasswordPageData = (actions: ActionMethods) => {
    const { t } = useTranslation('userSelf');
    const page: UserSelfPageData = {
        type: 'changePassword',
        title: (
            <PageTitle
                extra={
                    <ActionButton
                        key="submit"
                        form="changePasswordForm"
                        htmlType="submit"
                        icon={<CheckOutlined />}
                        type="link"
                    />
                }
                title={t('userSelf:passwordSettings.title')}
            />
        ),
        body: <ChangePasswordContent />,
        onMenuItemClicked: actions.goToChangePassword,
        onCloseOrBackClicked: actions.goBackToViewProfile,
    };

    return page;
};

export default useChangePasswordPageData;
